import { useCallback, useEffect, useState } from 'react';

export function useWindowSize() {
  const isClient = typeof window === 'object';

  // Mémoïsé : sans ça, `getSize` est recréé à chaque rendu et l'effet ne peut pas
  // le déclarer en dépendance sans se réabonner au resize en boucle.
  const getSize = useCallback(
    () => ({
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined
    }),
    [isClient]
  );

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    if (!isClient) {
      return;
    }

    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isClient, getSize]);

  return windowSize;
}
